// Статические данные магазинов (совпадают с steam_topup_new/visoria/stores.js)

export const OTHER_STORE_LIST = [
  { id: "nintendo", label: "Nintendo", bgClass: "region-bg-nintendo" },
  { id: "nintendo-membership", label: "Nintendo Online", bgClass: "region-bg-nintendo-membership" },
  { id: "steam", label: "Steam", bgClass: "region-bg-steam" },
  { id: "playstation", label: "PlayStation", bgClass: "region-bg-playstation" },
  { id: "xbox", label: "Xbox", bgClass: "region-bg-xbox" },
  { id: "xbox-game-pass", label: "Xbox Game Pass", bgClass: "region-bg-xbox-game-pass" },
  { id: "apple", label: "Apple", bgClass: "region-bg-apple" },
  { id: "spotify", label: "Spotify", bgClass: "region-bg-spotify" },
  { id: "fortnite", label: "Fortnite", bgClass: "region-bg-fortnite" },
  { id: "roblox", label: "Roblox", bgClass: "region-bg-roblox" },
  { id: "riot", label: "Riot Access", bgClass: "region-bg-riot" },
  { id: "pubg", label: "PUBG", bgClass: "region-bg-pubg" },
];

const OTHER_STORE_DETAILS = {
  nintendo: {
    pageTitle: "Nintendo eShop",
    genre: "карты пополнения Nintendo eShop",
    developer: "Nintendo Co., Ltd.",
    description:
      "Покупайте карты Nintendo eShop для Switch — мгновенное пополнение баланса без лишних шагов. Выбирайте удобный регион и номинал, оплачивайте через СБП и получайте код сразу после оплаты.",
  },
  steam: {
    pageTitle: "Steam",
    genre: "подарочные карты и пополнение кошелька Steam",
    developer: "Valve Corporation",
    description:
      "Пополняйте кошелёк Steam подарочными картами — покупайте игры, дополнения и внутриигровые предметы в пару кликов. Код приходит сразу после оплаты.",
  },
  playstation: {
    pageTitle: "PlayStation Network",
    genre: "карты пополнения PSN",
    developer: "Sony Interactive Entertainment",
    description:
      "Приобретайте карты PlayStation Network и моментально пополняйте кошелёк PSN. Покупайте игры и дополнения для PS4 и PS5.",
  },
  apple: {
    pageTitle: "Apple Gift Card",
    genre: "подарочные карты App Store и iTunes",
    developer: "Apple Inc.",
    description:
      "Подарочные карты Apple — пополнение баланса App Store, iTunes и Apple ID. Покупайте приложения, игры, музыку и фильмы.",
  },
  xbox: {
    pageTitle: "Xbox Gift Card",
    genre: "карты пополнения Xbox и Microsoft Store",
    developer: "Microsoft Corporation",
    description:
      "Карты Xbox помогут пополнить баланс Microsoft Store, купить игры для Xbox Series X|S и Xbox One или приобрести дополнения.",
  },
  spotify: {
    pageTitle: "Spotify Premium",
    genre: "карты подписки Spotify Premium",
    developer: "Spotify AB",
    description:
      "Карты подписки Spotify Premium — музыка без рекламы, офлайн-прослушивание и максимальное качество звука. Код активируется быстро.",
  },
  "xbox-game-pass": {
    pageTitle: "Xbox Game Pass",
    genre: "карты подписки Xbox Game Pass Ultimate, Premium и Essential",
    developer: "Microsoft Corporation",
    description:
      "Карты подписки Xbox Game Pass — сотни игр на консоли и PC, онлайн-мультиплеер и эксклюзивы Microsoft. Выберите тариф и срок, получите код сразу после оплаты.",
  },
  fortnite: {
    pageTitle: "Fortnite V-Bucks",
    genre: "внутриигровая валюта V-Bucks",
    developer: "Epic Games",
    description:
      "Пополняйте баланс V-Bucks для Fortnite — Battle Pass, скины и наборы в Item Shop. Код приходит сразу после оплаты.",
  },
  roblox: {
    pageTitle: "Roblox",
    genre: "Robux и подарочные карты Roblox",
    developer: "Roblox Corporation",
    description:
      "Подарочные карты Roblox — быстрый способ получить Robux и открыть доступ к аватарам, пропускам и платному контенту.",
  },
  "nintendo-membership": {
    pageTitle: "Nintendo Switch Online",
    genre: "карты подписки Nintendo Switch Online Individual и Family",
    developer: "Nintendo Co., Ltd.",
    description:
      "Карты подписки Nintendo Switch Online — онлайн-игра, облачные сохранения и каталог классических игр NES и SNES. Выберите Individual или Family и срок подписки.",
  },
  riot: {
    pageTitle: "Riot Access",
    genre: "Riot Points и подарочные коды Riot Games",
    developer: "Riot Games, Inc.",
    description:
      "Пополняйте Riot Points для League of Legends, VALORANT, Teamfight Tactics и других проектов Riot. Код выдаётся сразу после оплаты.",
  },
  pubg: {
    pageTitle: "PUBG Mobile UC",
    genre: "Unknown Cash (UC) и G-Coin для PUBG",
    developer: "KRAFTON, Inc.",
    description:
      "Покупайте UC и G-Coin для PUBG — внутриигровую валюту для Royal Pass, наборов и косметики. Код приходит моментально.",
  },
};

export function getOtherStoreDefinition(storeId) {
  const base = OTHER_STORE_LIST.find((store) => store.id === storeId);
  if (!base) {
    return null;
  }

  const details = OTHER_STORE_DETAILS[storeId] || {};
  return {
    ...base,
    ...details,
    regions: [],
  };
}
